import React, { useContext } from "react";
import Column from "components/ui/layout/column/column";
import CardBox from "components/ui/controls/card-box/card-box";
import Row from "components/ui/layout/row/row";
import { applyFormat } from "components/ui/ui-helpers";
import { AppContext } from "components/app/RemExprertProvider";

const DetailDeces = ({ Outil, TabDeces, TabRente, ClientConjoint }) => {
  const context = useContext(AppContext);

  // Icônes pour les différents types de prestations décès
  const getIconStyle = (category) => {
    if (category.includes("Capital décès")) return { emoji: "💰", background: "linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)" };
    if (category.includes("Double effet")) return { emoji: "⚡", background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)" };
    if (category.includes("Frais d'obsèques")) return { emoji: "⚱️", background: "linear-gradient(135deg, #6b7280 0%, #4b5563 100%)" };
    if (category.includes("Rente conjoint")) return { emoji: "💑", background: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)" };
    if (category.includes("Rente éducation")) return { emoji: "👶", background: "linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)" };
    return { emoji: "📋", background: "linear-gradient(135deg, #374151 0%, #1f2937 100%)" };
  };
  const handleRenteEducationRO = (DateNaissance) => {
    var today = new Date();
    var birthYear = parseInt(DateNaissance.slice(4));
    var age = today.getFullYear() - birthYear;
    if (age <= 12) {
      return TabRente[1]["Régime obligatoire"];
    } else if (age <= 18) {
      return TabRente[2]["Régime obligatoire"];
    } else if (age <= 25) {
      return TabRente[3]["Régime obligatoire"];
    } else {
      return 0;
    }
  };
  const handleRenteEducationRF = (DateNaissance) => {
    var today = new Date();
    var birthYear = parseInt(DateNaissance.slice(4));
    var age = today.getFullYear() - birthYear;
    if (age <= 12) {
      return TabRente[1]["Régime facultatif"];
    } else if (age <= 18) {
      return TabRente[2]["Régime facultatif"];
    } else if (age <= 25) {
      return TabRente[3]["Régime facultatif"];
    } else {
      return 0;
    }
  };
  return (
    <Column fill>
      <CardBox>
        <Column fill>
          <Row bpad>
            <div className="cotisations-container">
              <div className="cotisations-list-container">
                <div className="cotisations-header">
                  <div className="header-column"></div>
                  <div className="header-column">Prestations</div>
                  <div className="header-column">Régime(s) obligatoire(s)</div>
                  <div className="header-column">Régime(s) facultatif(s)</div>
                  <div className="header-column">Total</div>
                </div>

                {/* Capital décès / IAD toutes causes */}
                <div className="cotisations-card">
                  <div className="cotisations-card-icon" style={{ background: getIconStyle("Capital décès").background }}>
                    {getIconStyle("Capital décès").emoji}
                  </div>
                  <div className="card-column">Capital décès / IAD toutes causes</div>
                  <div className="card-column">{applyFormat(Math.max(0, TabDeces[0]["Régime obligatoire"]), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                  <div className="card-column">{applyFormat(Math.max(0, TabDeces[0]["Régime facultatif"]), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                  <div className="card-column">
                    {applyFormat(Math.max(0, Number(TabDeces[0]["Régime obligatoire"]) + Number(TabDeces[0]["Régime facultatif"])), "uint", { thousands: " ", decimal: ",", unit: " €" })}
                  </div>
                </div>

                {/* Capital décès / IAD accidentel */}
                <div className="cotisations-card">
                  <div className="cotisations-card-icon" style={{ background: getIconStyle("Capital décès").background }}>
                    {getIconStyle("Capital décès").emoji}
                  </div>
                  <div className="card-column">Capital décès / IAD accidentel</div>
                  <div className="card-column">{applyFormat(Math.max(0, TabDeces[1]["Régime obligatoire"]), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                  <div className="card-column">{applyFormat(Math.max(0, TabDeces[1]["Régime facultatif"]), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                  <div className="card-column">
                    {applyFormat(Math.max(0, Number(TabDeces[1]["Régime obligatoire"]) + Number(TabDeces[1]["Régime facultatif"])), "uint", { thousands: " ", decimal: ",", unit: " €" })}
                  </div>
                </div>

                {/* Double effet */}
                <div className="cotisations-card">
                  <div className="cotisations-card-icon" style={{ background: getIconStyle("Double effet").background }}>
                    {getIconStyle("Double effet").emoji}
                  </div>
                  <div className="card-column">Double effet</div>
                  <div className="card-column">0 €</div>
                  <div className="card-column">
                    {applyFormat(
                      Math.max(
                        0,
                        context.state[Outil + "ContratEnregistre" + ClientConjoint].reduce((prev, next) => Number(prev) + Number(next.DecesDoubleEffet), 0)
                      ),
                      "uint",
                      { thousands: " ", decimal: ",", unit: " €" }
                    )}
                  </div>
                  <div className="card-column">
                    {applyFormat(
                      Math.max(
                        0,
                        context.state[Outil + "ContratEnregistre" + ClientConjoint].reduce((prev, next) => Number(prev) + Number(next.DecesDoubleEffet), 0)
                      ),
                      "uint",
                      { thousands: " ", decimal: ",", unit: " €" }
                    )}
                  </div>
                </div>

                {/* Frais d'obsèques */}
                <div className="cotisations-card">
                  <div className="cotisations-card-icon" style={{ background: getIconStyle("Frais d'obsèques").background }}>
                    {getIconStyle("Frais d'obsèques").emoji}
                  </div>
                  <div className="card-column">Frais d'obsèques</div>
                  <div className="card-column">0 €</div>
                  <div className="card-column">
                    {applyFormat(
                      Math.max(
                        0,
                        context.state[Outil + "ContratEnregistre" + ClientConjoint].reduce((prev, next) => Number(prev) + Number(next.FraisObseque), 0)
                      ),
                      "uint",
                      { thousands: " ", decimal: ",", unit: " €" }
                    )}
                  </div>
                  <div className="card-column">
                    {applyFormat(
                      Math.max(
                        0,
                        context.state[Outil + "ContratEnregistre" + ClientConjoint].reduce((prev, next) => Number(prev) + Number(next.FraisObseque), 0)
                      ),
                      "uint",
                      { thousands: " ", decimal: ",", unit: " €" }
                    )}
                  </div>
                </div>

                {/* Rente conjoint */}
                <div className="cotisations-card">
                  <div className="cotisations-card-icon" style={{ background: getIconStyle("Rente conjoint").background }}>
                    {getIconStyle("Rente conjoint").emoji}
                  </div>
                  <div className="card-column">Rente conjoint</div>
                  <div className="card-column">{applyFormat(Math.max(0, TabRente[0]["Régime obligatoire"]), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                  <div className="card-column">{applyFormat(Math.max(0, TabRente[0]["Régime facultatif"]), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                  <div className="card-column">
                    {applyFormat(Math.max(0, TabRente[0]["Régime obligatoire"] + TabRente[0]["Régime facultatif"]), "uint", { thousands: " ", decimal: ",", unit: " €" })}
                  </div>
                </div>

                {/* Rentes éducation pour les enfants */}
                {context.state.TableauEnfant.map(
                  (Enfant, Index) =>
                    Enfant.Charge !== "none" && (
                      <div key={Index} className="cotisations-card">
                        <div className="cotisations-card-icon" style={{ background: getIconStyle("Rente éducation").background }}>
                          {getIconStyle("Rente éducation").emoji}
                        </div>
                        <div className="card-column">Rente éducation pour {Enfant.Prenom}</div>
                        <div className="card-column">
                          {applyFormat(Math.max(0, handleRenteEducationRO(Enfant.DateNaissance, Enfant.Charge)), "uint", { thousands: " ", decimal: ",", unit: " €" })}
                        </div>
                        <div className="card-column">{applyFormat(Math.max(0, handleRenteEducationRF(Enfant.DateNaissance)), "uint", { thousands: " ", decimal: ",", unit: " €" })}</div>
                        <div className="card-column">
                          {applyFormat(Math.max(0, handleRenteEducationRO(Enfant.DateNaissance) + handleRenteEducationRF(Enfant.DateNaissance)), "uint", {
                            thousands: " ",
                            decimal: ",",
                            unit: " €",
                          })}
                        </div>
                      </div>
                    )
                )}
              </div>
            </div>
          </Row>
        </Column>
      </CardBox>
    </Column>
  );
};

export default DetailDeces;
